import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
@Injectable()
export class DiscountService {
  private readonly DiscountEndpoint = '/api/discount/';
  constructor(private http: HttpClient) { }
formData;
  addDiscount(discount: any,file:any) {
      console.log(discount);
      console.log("coment : "+discount.comment);
      discount.discountFile=file;
      console.log("file")
      console.log(file);
      console.log("discountFile");
      console.log(discount.discountFile);
    this.formData = new FormData();
    this.formData.append('comment', discount.comment);
    this.formData.append('discountFile', file);
    this.formData.append('discountAmount',discount.discountAmount);
    this.formData.append('studentID',discount.studentID);
    return this.http.post(this.DiscountEndpoint + "AddDiscount/", this.formData);
  }
  getDiscount(searchKey, discountAmount, discountAmountTo, departmentId, branchId) {
    return this.http.post(this.DiscountEndpoint + `GetDiscount?searchKey=${searchKey}&discountAmount=${discountAmount}&discountAmountTo=${discountAmountTo}&departmentId=${departmentId}&branchId=${branchId}`, null);
  }

  getStudentDiscount(studentId, studentName, semesterId, yearId, entrySemesterId, departmentId, branchId) {
    return this.http.post(this.DiscountEndpoint + `GetStudentDiscount?studentId=${studentId}&studentName=${studentName}&semesterId=${semesterId}&yearId=${yearId}&entrySemesterId=${entrySemesterId}&departmentId=${departmentId}&branchId=${branchId}`, null);
  }
  getDiscountA(searchKey) {
    return this.http.post(this.DiscountEndpoint + `GetDiscountA?searchKey=${searchKey}`, null);
  }
  //getDiscountA(discount: any) {
  //  return this.http.post(this.DiscountEndpoint + "GetDiscountA/", discount);
  //}
  getAllDiscount(discount: any, branchId: number) {
    return this.http.post(this.DiscountEndpoint + `GetDiscount?searchKey=0&discountAmount=0&branchId=${branchId}`, null);
  }
  getOldDiscounts(studentID: string, semester: string) {
    return this.http.get(this.DiscountEndpoint + `GetOldDiscounts/${studentID}/${semester}`);
  }
  deleteDiscount(discountID: string) {
    return this.http.delete(this.DiscountEndpoint + `DeleteDiscount/${discountID}`);
  }
  editDiscount(discount: any) {
    return this.http.put(this.DiscountEndpoint + "EditDiscount/", discount);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/DiscountService.ts